<template>
  <BoxDetailsDrawerSectionCard :title="t('box_details.details_drawer.tags')">
    <template #append>
      <VBtnPrimary
        :disabled="deepBoxTagsStore.assignTagPending || disableBtnAddTags"
        name="btn-box-details-drawer-tags-assign"
        variant="text"
        @click.stop="showDialogNodeAssignTag = true"
      >
        {{ t('box_details.details_drawer.sections.tags.assign') }}
      </VBtnPrimary>
    </template>
    <template v-if="node.tags.length" #content>
      <div class="pb-2">
        <DeepNodeTag
          v-for="tag in node.tags"
          :key="tag.key"
          class="pa-3 ma-1"
          closable
          density="compact"
          :tag="tag"
          @click="searchByTag(tag.key)"
          @click:close="onRemoveTag(tag)"
        />
      </div>
    </template>
  </BoxDetailsDrawerSectionCard>
  <!-- Assign Tag Dialog -->
  <DialogNodeAssignTag
    v-model="showDialogNodeAssignTag"
    :box-id="boxId"
    :nodes="[node]"
    :organization-id="organizationId"
    :type-id="typeId"
    @success="
      emit('update:tags', {
        nodeId: node.nodeId ?? '',
        tags: $event.tags,
      })
    "
  />
  <!-- /Assign Tag Dialog -->
</template>

<script setup lang="ts">
import { toast } from 'vue-sonner'
import { DKitDeepBoxTagsAssignOnUpdateTags } from '@deepcloud/deep-ui-kit'
import { DeepNodeTag } from '@deepcloud/deep-ui-lib'
import { useDeepBoxTagsStore } from '@/stores/deepbox/deepboxes/tags.ts'
import BoxDetailsDrawerSectionCard from '@/components/box/details-drawer/BoxDetailsDrawerSectionCard.vue'
import DialogNodeAssignTag from '@/components/dialogs/DialogNodeAssignTag.vue'
import { getSearchByTagRouteQuery } from '@/components/search/search-by-tag.ts'
import type { Node, Tag } from '@deepcloud/api-deep-box'
import type { PropType } from 'vue'

const props = defineProps({
  organizationId: {
    type: String,
    required: true,
  },
  typeId: {
    type: String,
    required: true,
  },
  boxId: {
    type: String,
    required: true,
  },
  node: {
    type: Object as PropType<Node>,
    required: true,
  },
})

const emit = defineEmits<{
  'update:tags': [DKitDeepBoxTagsAssignOnUpdateTags]
}>()

const { t } = useI18n()
const router = useRouter()

const deepBoxTagsStore = useDeepBoxTagsStore()

const showDialogNodeAssignTag = ref(false)

const disableBtnAddTags = computed(
  () => props.typeId === undefined || props.boxId === undefined,
)

function searchByTag(tagKey: string) {
  deepBoxTagsStore.setTag(tagKey)
  if (props.typeId && props.boxId) {
    router.push({
      name: 'organization-types-type-boxes-box-search',
      params: {
        type: props.typeId,
        box: props.boxId,
      },
      query: getSearchByTagRouteQuery(tagKey),
    })
  }
}

async function onRemoveTag(tag: Tag) {
  if (!props.node?.tags) return
  let tags = [...props.node.tags]
  tags = tags.filter((displayItemTag) => displayItemTag.key !== tag.key)
  try {
    await deepBoxTagsStore.updateNodeTags({
      nodeId: props.node.nodeId,
      tags,
    })
    emit('update:tags', {
      nodeId: props.node.nodeId,
      tags,
    })
  } catch {
    toast.error(t('error.error_occurred'))
  }
}
</script>
